import React from 'react';
import { SectionHeading } from '../components/ui/SectionHeading';
import { ScrollReveal } from '../components/ui/ScrollReveal';
import { Button } from '../components/ui/Button';
export function ActivationsPage() {
  return <div className="w-full pt-24" data-id="element-390">
      <section className="py-24 md:py-32 bg-brand-green-deep text-brand-cream-light relative overflow-hidden" data-id="element-391">
        <div className="absolute inset-0 bg-concept-challenge opacity-50 mix-blend-overlay" data-id="element-392" />
        <div className="max-w-7xl mx-auto px-6 relative z-10" data-id="element-393">
          <SectionHeading eyebrow="Activations & Events" title="Branded golf experiences for unforgettable moments." subtitle="Temporary or permanent installations designed for gatherings, launches, and social competition." light data-id="element-394" />
        </div>
      </section>

      <section className="py-24 bg-brand-cream" data-id="element-395">
        <div className="max-w-7xl mx-auto px-6 text-center" data-id="element-396">
          <ScrollReveal data-id="element-397">
            <h2 className="text-4xl font-heading text-brand-green-deep mb-16" data-id="element-398">
              Brandable Moments
            </h2>
          </ScrollReveal>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-399">
            {[{
            title: 'Corporate Events',
            desc: 'Custom-branded challenge greens for team building and client entertainment.'
          }, {
            title: 'Brand Pop-ups',
            desc: 'Highly visual, temporary installations designed for product launches and PR moments.'
          }, {
            title: 'Tournament VIP',
            desc: 'Premium hospitality areas for existing golf events and sponsorships.'
          }].map((item, i) => <ScrollReveal key={i} delay={i * 0.1} data-id="element-400">
                <div className="bg-brand-cream-light p-8 rounded-sm border border-brand-stone/20 h-full" data-id="element-401">
                  <h3 className="text-xl font-heading text-brand-green-deep mb-4" data-id="element-402">
                    {item.title}
                  </h3>
                  <p className="text-brand-stone font-body" data-id="element-403">{item.desc}</p>
                </div>
              </ScrollReveal>)}
          </div>
          <div className="mt-16" data-id="element-404">
            <Button variant="primary" href="/contact" data-id="element-405">
              Plan an Activation
            </Button>
          </div>
        </div>
      </section>
    </div>;
}